import Collection from 'components/Collection/Collection'
import Footer from 'components/shared/Footer/Footer'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import Loader from 'components/shared/Loader/Loader'
import NoMatch from 'components/shared/NoMatch/NoMatch'
import SiteHeader from 'components/shared/SiteHeader/SiteHeader'
import { themeClassName } from 'helpers/Project'
import { withRouter } from 'helpers/withRouter'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { withCookies } from 'react-cookie'
import { withNamespaces } from 'react-i18next'
import { connect } from 'react-redux'
import { fetchCollection } from 'redux/actions/CollectionActions'

const CollectionContainer = ({
  cookies,
  fetchCollectionAction,
  i18n,
  collection,
  router: {
    params: { slug },
  },
  user,
}) => {
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    const access_token = user ? user.access_token || null : null
    if (cookies.cookies.sessionProgress || access_token) {
      fetchCollectionAction(
        i18n.language,
        slug,
        access_token,
        cookies.cookies.sessionProgress
      )
    }
  }, [
    fetchCollectionAction,
    i18n.language,
    user,
    cookies.cookies.sessionProgress,
  ])

  useEffect(() => {
    setShouldRender(true)
  }, [])

  const { theme: [{ name: colour = null } = {}] = [] } = collection || {}

  return (
    <div>
      <HtmlHead
        title={collection.metaTitle}
        description={collection.metaDescription}
      />
      <SiteHeader locale={i18n.language} />
      <NoMatch error={collection.error} />
      <Loader display={collection.loading || collection.slug !== slug} />
      {shouldRender && !collection.loading && (
        <div className={themeClassName(colour)}>
          <Collection locale={i18n.language} collection={collection} />
          <Footer
            text="project.footer.feedback.homepage.text"
            userID="collection-footer-user-id"
          />
        </div>
      )}
    </div>
  )
}

CollectionContainer.propTypes = {
  cookies: PropTypes.object,
  fetchCollectionAction: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string.isRequired,
  }).isRequired,
  collection: PropTypes.object.isRequired,
  router: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  user: PropTypes.object,
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCollectionAction: (locale, slug, authToken, session) =>
      dispatch(fetchCollection(locale, slug, authToken, session)),
  }
}

const mapStateToProps = ({ collection = {}, authentication }) => {
  return { collection, user: authentication.user }
}

export { CollectionContainer }
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces('translations')(withCookies(withRouter(CollectionContainer))))
